import { createConsumer } from '@rails/actioncable'

// Create the Action Cable consumer
// It will automatically connect to the websocket endpoint at /cable
const cable = createConsumer()

export default cable
